import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])

export const pageSearch = {
  /*'customerCode': {
    title: '客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户选择'
    }
  }, */
  'settlementNo': {
    title: '结算单号',
    type: 'input',
    equation: all
  }
  /*'startDay': {
    title: '结算起始日期',
    type: 'date',
    equation: all,
    valueFormat: 'yyyy-MM-dd'
  },
  'endDay': {
    title: '结算结束日期',
    type: 'date',
    equation: all,
    valueFormat: 'yyyy-MM-dd'
  }
  'status': {
    title: '状态',
    type: 'select',
    dictionary: 'goodsPlanType',
    equation: all
  }*/
}

export default {
  'settlementNo': {
    title: '结算单号',
    width: '100',
    slot: true
  },
  'createdDate': {
    title: '结算日期',
    width: '140'
  },
  'startDay': {
    title: '结算开始日期',
    width: '150'
  },
  'endDay': {
    title: '结算截止日期',
    width: '150'
  },
  'discount': {
    title: '扣款金额',
    width: '120'
  },
  'comment': {
    title: '备注',
    width: 'auto'
  },
  'createdByName': {
    title: '操作人',
    width: '120'
  }

}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/data-searching/config/deliveryFeeSearch.js